export enum RouteIds {
	login = 'auth.iam/login',
	logout = 'auth.iam/logout',
	forgotPassword = 'auth.iam/forgot-password',
	setPassword = 'auth.iam/set-password',
	activation = 'auth.iam/activation',
	emptyOrgs = 'auth.iam/empty-orgs',
	saasReclamation = 'auth.iam/saas-reclamation'
}
